
const host = 'https://static.shikehuyu.com/ddyc/res'
const keys = [
  ['bg', 'chat1', 'chat2', 'chat3', 'rect', 'text'],
  ['bg', 'chat1', 'chat2', 'chat3v2', 'rect', 'text', 'light'],
  ['bgv3', 'chat', 'tag', 'text', 'light', 'hand'],
]
const sprites = []
keys.forEach((list, index) => {
  list.forEach(key => {
    sprites.push({
      name: `s${index + 1}_${key}`,
      url: `${host}/scenes/s${index + 1}/${key}.png`
    })
  })
})

const others = [
  'ending_bg',
  'scene1_bg', 'scene1_bottomv3',
  'scene2_bg', 'scene2_bottomv3', 'scene2_light',
  'scene3_bgv2', 'scene3_bottomv3',
]
others.forEach((key) => {
  sprites.push({
    name: key,
    url: `${host}/imgs/${key}.png`
  })
})

export default sprites

